module.exports = __webpack_public_path__ + "img/第7章_3-2_手稿.jpg";